<template>
    <div>
        <div v-for="(instruction, ndx) in driverInstructionsList" class="detail-group" :key="`instruction-${ndx}`">
            <label class="label">{{ instruction.text }}:</label>
            <span class="value">
                {{ instruction.value }}
            </span>
        </div>
    </div>
</template>

<script>
import { DRIVER_INSTRUCTIONS_OPTIONS } from '@/utils/constants';

export default {
    name: 'DriverInstructions',
    props: {
        driverInstructions: { type: Object, default: () => null }
    },
    computed: {
        driverInstructionsList() {
            const list = [];

            if (this.driverInstructions) {
                DRIVER_INSTRUCTIONS_OPTIONS.forEach((x) => {
                    if (this.driverInstructions[x.key] !== undefined && this.driverInstructions[x.key] !== null) {
                        if (typeof this.driverInstructions[x.key] === 'boolean') {
                            list.push({ ...x, value: this.driverInstructions[x.key] ? 'Yes' : 'No' });
                        } else {
                            list.push({ ...x, value: this.driverInstructions[x.key] });
                        }
                    }
                });
            }

            list.sort((a, b) => {
                if (a.value === 'Yes' && b.value === 'Yes') {
                    return a.order > b.order ? 1 : -1;
                }
                if (a.value === 'Yes' && b.value === 'No') {
                    return -1;
                }
                if (a.value === 'No' && b.value === 'Yes') {
                    return 1;
                }
                return a.order > b.order ? 1 : -1;
            });

            return list;
        }
    }
};
</script>

<style lang="scss" scoped>
.detail-group {
    padding: 2px 16px;
    margin: 5px 0;
    font-size: 0.9em;
    .label {
        display: inline-block;
        width: 160px;
        margin-right: 4px;
        vertical-align: top;
        font-weight: 400;
    }

    .value {
        display: inline-block;
        width: calc(100% - 175px);
        vertical-align: top;
        a {
            color: #2b93ff;
        }
    }
}
</style>
